// import heightMatcher from './utilities/heightMatcher';
// import StickyMenu from './components/stickyMenu';
import Swiper, { Autoplay } from 'swiper';

Swiper.use([Autoplay]);

new Swiper('.slider', {
	slidesPerView: 1,
	centeredSlides: true,
	effect: 'slide',
	loop: true,
	autoplay: {
		delay: 5000,
	},
});

// let windowWidth = $(window).width();

// if (windowWidth > 1024) {
// 	let firstTable = $('section.table').first()
// 	firstTable.find('.table-row:not(:first-child)').slideDown(200);
// 	firstTable.find('.table-row .table-row__text, .table-row .table-row__subtitle').slideDown(200);
// 	firstTable.addClass('expanded');
// }

$('[data-expand]').on('click', function(e) {
	e.preventDefault();
	// console.log('clicks');
	let thisTable = $(this).parent().parent();

	thisTable.toggleClass('expanded');

	if (thisTable.hasClass('expanded')) {
		thisTable.find('.table-row:not(:first-child)').slideDown(0);
		thisTable.find('.table-row .table-row__text, .table-row .table-row__subtitle').slideDown(0);
	} else {
		thisTable.find('.table-row:not(:first-child)').slideUp(0);
		thisTable.find('.table-row .table-row__text, .table-row .table-row__subtitle').slideUp(0);
	}

	// if (thisTable.hasClass('expanded')) {
	// 	console.log(thisTable.hasClass('expanded'));
	// 	thisTable.find('.table-row__text, .table-row__subtitle').fadeIn(200);
	// 	// thisTable.removeClass('expanded');
	// } else {
	// 	thisTable.find('.table-row__text, .table-row__subtitle').fadeOut(200);
	// 	// thisTable.addClass('expanded');
	// }
	// $(this).parent().parent().find('.table-row__text').addClass('wOOOOOOO');
});

var input = document.querySelector('#mce-EMAIL'); // get the input element
input.addEventListener('input', resizeInput); // bind the "resizeInput" callback on "input" event
resizeInput.call(input); // immediately call the function

function resizeInput() {
	this.style.width = (this.value.length > 0) ? this.value.length + "ch":'10ch';
}

// OWL CAROUSEL REMOVED => This has been kept for the options to be translated for Swiper
// const ocOptions = oc.data('carousel-options');
// const defaults = {
//   items: 1,
//   loop: true,
//   autoplay: true,
//   autoplayHoverPause: true,
//   checkVisible: false
// };
